module.exports = __webpack_public_path__ + "static/img/p12.16f6cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p12.png
// module id = +5R3
// module chunks = 0